module.exports = __webpack_public_path__ + "static/media/Solacoat.d4adc04c.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Solacoat.png
// module id = 350
// module chunks = 0